/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_MenuInputs */

const en_insert_menu = /** @type {(inputs: Insert_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert menu`)
};

const fr_insert_menu = /** @type {(inputs: Insert_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu insertion`)
};

const de_insert_menu = /** @type {(inputs: Insert_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü einfügen`)
};

const it_insert_menu = /** @type {(inputs: Insert_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci menu`)
};

const ru_insert_menu = /** @type {(inputs: Insert_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить меню`)
};

const es_insert_menu = /** @type {(inputs: Insert_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú Insertar`)
};

const zh_cn2_insert_menu = /** @type {(inputs: Insert_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入菜单`)
};

const ja_insert_menu = /** @type {(inputs: Insert_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`挿入メニュー`)
};

const hi_insert_menu = /** @type {(inputs: Insert_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेनू डालें`)
};

const pt_pt2_insert_menu = /** @type {(inputs: Insert_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir menu`)
};

/**
* | output |
* | --- |
* | "Insert menu" |
*
* @param {Insert_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_menu = /** @type {((inputs?: Insert_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_menu(inputs)
	if (locale === "de") return de_insert_menu(inputs)
	if (locale === "it") return it_insert_menu(inputs)
	if (locale === "ru") return ru_insert_menu(inputs)
	if (locale === "es") return es_insert_menu(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_menu(inputs)
	if (locale === "ja") return ja_insert_menu(inputs)
	if (locale === "hi") return hi_insert_menu(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_menu(inputs)
	return en_insert_menu(inputs)
});